import { render, staticRenderFns } from "./liaison.vue?vue&type=template&id=514f4b48&scoped=true&"
import script from "./liaison.vue?vue&type=script&lang=js&"
export * from "./liaison.vue?vue&type=script&lang=js&"
import style0 from "./liaison.vue?vue&type=style&index=0&id=514f4b48&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "514f4b48",
  null
  
)

export default component.exports